const styles = {
  mainArea: {
    padding: 16,
    marginTop: 64,
  },
  relatedPanel: {
    backgroundColor: "white",
  },
};
export default styles;
